import { Endpoint } from '@business/api/endpoint';
import { InvoiceScheduleId, InvoiceScheduleResponse } from '@business/entities/invoiceSetting';
import { InvoiceScheduleFormData } from '@modules/invoice/Tabs/InvoiceSchedule/AddEditInvoiceScheduleModal/AddEditInvoiceScheduleModal';

export function fetchInvoiceSchedules() {
  return Endpoint.get<InvoiceScheduleResponse[]>(`@gc/invoice-schedules`);
}

export function createInvoiceSchedule(data: InvoiceScheduleFormData) {
  return Endpoint.post<InvoiceScheduleResponse>(`@gc/invoice-schedules`, { data });
}

export function updateInvoiceSchedule(invoiceScheduleId: InvoiceScheduleId, data: InvoiceScheduleFormData) {
  return Endpoint.patch<InvoiceScheduleResponse>(`@gc/invoice-schedules/${invoiceScheduleId}`, { data });
}

export function deleteInvoiceSchedule(invoiceScheduleId: InvoiceScheduleId) {
  return Endpoint.delete<void>(`@gc/invoice-schedules/${invoiceScheduleId}`);
}

export function fetchInvoiceSchedule(invoiceScheduleId: InvoiceScheduleId) {
  return Endpoint.get<InvoiceScheduleResponse>(`@gc/invoice-schedules/${invoiceScheduleId}`);
}
